const STORAGE_PREFIX = "peer-start-product-tour:";
const SESSION_PREFIX = "peer-start-product-tour-session:";

export function hasCompletedProductTour(employeeId: string): boolean {
  try {
    return localStorage.getItem(`${STORAGE_PREFIX}${employeeId}`) === "done";
  } catch {
    return false;
  }
}

export function markProductTourCompleted(employeeId: string): void {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${employeeId}`, "done");
  } catch {
    // Ignore quota / private-mode failures; the tour can simply reappear.
  }
}

export function clearProductTourProgress(employeeId: string): void {
  try {
    localStorage.removeItem(`${STORAGE_PREFIX}${employeeId}`);
  } catch {
    // Ignore storage failures.
  }
}

export function isProductTourDismissedForSession(employeeId: string): boolean {
  try {
    return sessionStorage.getItem(`${SESSION_PREFIX}${employeeId}`) === "dismissed";
  } catch {
    return false;
  }
}

export function dismissProductTourForSession(employeeId: string): void {
  try {
    sessionStorage.setItem(`${SESSION_PREFIX}${employeeId}`, "dismissed");
  } catch {
    // Ignore storage failures; the tour can simply reappear.
  }
}

export function clearProductTourSessionDismissal(employeeId: string): void {
  try {
    sessionStorage.removeItem(`${SESSION_PREFIX}${employeeId}`);
  } catch {
    // Ignore storage failures.
  }
}

export function clearAllProductTourSessionDismissals(): void {
  try {
    const keys: string[] = [];
    for (let index = 0; index < sessionStorage.length; index += 1) {
      const key = sessionStorage.key(index);
      if (key?.startsWith(SESSION_PREFIX)) keys.push(key);
    }
    for (const key of keys) sessionStorage.removeItem(key);
  } catch {
    // Ignore storage failures during sign-out.
  }
}

/** Clears every employee tour flag (call on prototype_reset). */
export function clearAllProductTourProgress(): void {
  try {
    const keys: string[] = [];
    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index);
      if (key?.startsWith(STORAGE_PREFIX)) keys.push(key);
    }
    for (const key of keys) localStorage.removeItem(key);
  } catch {
    // Ignore storage failures during demo reset.
  }
}
